import React from 'react';
import { filterNotHiddenProducts, getTernaryValue } from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { RESULTS, WE_FOUND_TEXT } from '../MenuPLPConstants/MenuPLPConstants';
import { Row } from 'react-bootstrap';

const SearchItems = ({ searchMode, filterList, dietaryList, isMobile, products }) => {
  const getClassName = dataList => {
    if (dataList.find(item => item.toLowerCase() === 'all')) {
      return 'all-data-found-plp';
    }
    return 'data-found-plp';
  };

  return searchMode.isSearchedMode && filterNotHiddenProducts(products) > 0 ? (
    <Row className={getTernaryValue(isMobile, 'search-box', 'pt-5')}>
      <h3 className='found-text'>
        {translateWithI18Next(WE_FOUND_TEXT)} {filterNotHiddenProducts(products)}
        {` "${searchMode.searchedData.toUpperCase()}"`}
      </h3>
    </Row>
  ) : (
    ([...filterList, ...dietaryList].length > 0 && filterNotHiddenProducts(products) === 0 && (
      <Row className={getTernaryValue(isMobile, 'search-box', 'pt-5 no-data-found-plp')}>
        <h2 className='found-text'>
          {translateWithI18Next(WE_FOUND_TEXT)} {filterNotHiddenProducts(products)} {RESULTS.toUpperCase()}
        </h2>
      </Row>
    )) ||
      ([...filterList, ...dietaryList].length > 0 && filterNotHiddenProducts(products) > 0 && (
        <Row className={getTernaryValue(isMobile, 'search-box', `pt-5 ${getClassName(dietaryList)}`)}>
          <h2 className='found-text'>
            {translateWithI18Next(WE_FOUND_TEXT)} {filterNotHiddenProducts(products)} {RESULTS.toUpperCase()}
          </h2>
        </Row>
      ))
  );
};

export default React.memo(SearchItems);
